import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Viewinterview() {
  const [meetings, setMeetings] = useState([]);
  const [error, setError] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const api = process.env.REACT_APP_API;
  const navi =useNavigate()
  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${api}/meeting/viewinterview`);
      setMeetings(response.data);
    } catch (err) {
      console.error('Error fetching meetings:', err);
      setError('Failed to load meeting data');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAction = async (id) => {
    try {
      await axios.get(`${api}/meeting/interviewselected/${id}`);
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };

  const handleConfirmClick = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleConfirmYes = () => {
    handleAction(selectedId);
    setShowModal(false);
  };

  const handleConfirmNo = () => {
    setSelectedId(null);
    setShowModal(false);
  };

  const filteredMeetings = meetings.filter((meeting) => {
    const query = searchQuery.toLowerCase();
    return (
      meeting.name?.toLowerCase().includes(query) ||
      meeting.gender?.toLowerCase().includes(query) ||
      meeting.age?.toString().includes(query) ||
      meeting.cell?.includes(query) ||
      meeting.taluk?.toLowerCase().includes(query) ||
      meeting.interviewSlot?.toLowerCase().includes(query) ||
      meeting.have?.toLowerCase().includes(query) ||
      (meeting.selected === 'yes' ? 'selected' : 'not selected').includes(query)
    );
  });

  return (
    <div style={{ padding: '30px', fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#f9f9f9' }}>
      <h2>🗓️ Meeting List</h2>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Search by name, phone, taluk, etc..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            padding: '10px',
            width: '100%',
            maxWidth: '400px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            fontSize: '14px'
          }}
        />
      </div>

      {meetings.length === 0 && !error ? (
        <p>Loading meetings...</p>
      ) : (
        <div style={{ overflowX: 'auto', border: '1px solid #ddd', borderRadius: '6px', backgroundColor: '#fff' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
            <thead>
              <tr style={{ backgroundColor: '#004080', color: '#fff' }}>
                {['#', 'Name', 'Gender', 'Age', 'Phone', 'Taluk', 'Interview Slot', 'Have', 'Status', 'Action'].map((title, i) => (
                  <th key={i} style={thStyle}>{title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredMeetings.length > 0 ? (
                filteredMeetings.map((meeting, index) => (
                  <tr key={meeting.id} style={index % 2 === 0 ? rowEvenStyle : rowOddStyle}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={tdStyle}>{meeting.name}</td>
                    <td style={tdStyle}>{meeting.gender}</td>
                    <td style={tdStyle}>{meeting.age}</td>
                    <td style={tdStyle}>{meeting.cell}</td>
                    <td style={tdStyle}>{meeting.taluk || '—'}</td>
                    <td style={tdStyle}>{meeting.interviewSlot}</td>
                    <td style={tdStyle}>{meeting.have}</td>
                    <td style={tdStyle}>
                      {meeting.selected === 'yes' ? '✅ Selected' : '❌ Not selected'}
                    </td>
                    <td style={tdStyle}>
                      <button
                        style={{
                          ...buttonStyle,
                          backgroundColor: meeting.selected === 'yes' ? '#6c757d' : '#007bff',
                          cursor: meeting.selected === 'yes' ? 'not-allowed' : 'pointer'
                        }}
                        disabled={meeting.selected === 'yes'}
                        onClick={() => handleConfirmClick(meeting.id)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" style={{ ...tdStyle, textAlign: 'center', padding: '20px' }}>
                    No results found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <p>Are you sure you want to mark this as <b>"in"</b>?</p>
            <div style={{ marginTop: '15px' }}>
              <button style={modalButtonStyle} onClick={handleConfirmYes}>Yes</button>
              <button style={{ ...modalButtonStyle, marginLeft: '10px' }} onClick={handleConfirmNo}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const thStyle = {
  borderBottom: '2px solid #ccc',
  padding: '12px 10px',
  textAlign: 'left',
  fontSize: '14px',
  fontWeight: '600',
};

const tdStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  fontSize: '14px',
};

const rowEvenStyle = { backgroundColor: '#ffffff' };
const rowOddStyle = { backgroundColor: '#f9f9f9' };

const buttonStyle = {
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: '4px',
  fontSize: '13px',
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: '#fff',
  padding: '30px 25px',
  borderRadius: '12px',
  width: '340px',
  textAlign: 'center',
  boxShadow: '0 15px 30px rgba(0, 0, 0, 0.2)',
};

const modalButtonStyle = {
  padding: '10px 20px',
  borderRadius: '8px',
  border: 'none',
  backgroundColor: '#007bff',
  color: '#fff',
  fontSize: '15px',
  fontWeight: '500',
  cursor: 'pointer',
};

export default Viewinterview;
